import React, { ReactNode, SyntheticEvent } from "react";
import styled from "styles/styled_components";

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: ${(props) => props.theme.layering.overlay};
  background: ${(props) => props.theme.colors.transparentBlack};
  transition: background 0.4s ease-out;
`;

interface IOverlay {
  onClick: (event: SyntheticEvent) => void;
  children: ReactNode;
}

export default function Overlay({ onClick, children }: IOverlay) {
  return (
    <StyledOverlay
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClick(event);
        }
      }}
    >
      {children}
    </StyledOverlay>
  );
}
